import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import IconNotResult from '../../assets/images/common/icon-not_result.svg';
import IconMailWihte from '../../assets/images/common/icon-mail-wihte.svg';

import { ErrorMessage } from '../../components/ErrorMessage';
import { SearchTextField } from '../../components/SearchTextField';

type SearchResultRowProps = {
    searchWord: string;
    searchWordDeviceListAdd: (value: string) => boolean;
    errorMessages: Array<string>;
};

export const SearchResultNotFound: React.FC<SearchResultRowProps> = ({
    searchWord,
    searchWordDeviceListAdd,
    errorMessages,
}) => {
    const navigation = useNavigate();

    // 機器リスト追加
    const notFoundSearchWordDeviceListAdd = () => {
        if (searchWordDeviceListAdd(searchWord)) {
            navigation('/editDeviceList');
        }
    };

    return (
        <>
            <section className='section page_title not_result'>
                <div className='container'>
                    <div className='columns'>
                        <div className='column is-12 page_title-thead'>
                            <h1>
                                <span className='not_result--keyword'>{searchWord}</span>
                                に関する機種は見つかりませんでした。
                            </h1>
                        </div>
                    </div>
                    <div className='columns not_result--search_box is-variable is-2-mobile is-2-tablet is-6-desktop is-6-widescreen is-6-fullhd'>
                        <div className='column'>
                            <p className='discription'>こちらから再入力・再検索を行ってください。</p>
                            <SearchTextField inputClassName='input is-top_search' buttonClassName='button is-dl_gra' />
                        </div>
                        <div className='column'>
                            <p className='discription'>検索したキーワードから見積を依頼する事も可能です。</p>
                            <a className='button is-dl_blue' onClick={notFoundSearchWordDeviceListAdd}>
                                <span>このキーワードを保存して見積依頼をする</span>
                                <span className='icon is-small ml-3'>
                                    <img src={IconNotResult} alt='' />
                                </span>
                            </a>
                            {errorMessages.length > 0 &&
                                errorMessages.map((message, index) => (
                                    <div className='columns search_results--text' key={`${message}-${index}`}>
                                        <div className='column'>
                                            <ErrorMessage errorMessage={message} />
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </section>
            <section className='section bottom_cta'>
                <div className='container'>
                    <div className='columns'>
                        <div className='column'>
                            <div className='bottom_cta--next'>
                                <p className='bottom_cta--next_text'>
                                    検索機種名、キーワードが分からない場合などはお気軽にお問い合わせください。
                                </p>
                                <Link to='/contact/noSearchWord' className='button is-dl_blue'>
                                    検索したキーワードでお問い合わせする
                                    <span className='icon is-small'>
                                        <img src={IconMailWihte} alt='' />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
